// context/ConsentContext.tsx
import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  ReactNode,
} from "react";

interface ConsentContextType {
  consentGiven: boolean;
  acceptCookies: () => void;
  rejectCookies: () => void;
}

const ConsentContext = createContext<ConsentContextType | null>(null);

export const ConsentProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [consentGiven, setConsentGiven] = useState<boolean>(false);

  // Check if user already accepted (stored in localStorage)
  useEffect(() => {
    const hasConsented = localStorage.getItem("cookieConsent");
    if (hasConsented === "accepted") {
      setConsentGiven(true);
    }
  }, []);

  const acceptCookies = () => {
    setConsentGiven(true);
    localStorage.setItem("cookieConsent", "accepted");

    // Initialize Google Analytics NOW
    initializeGoogleAnalytics();
  };

  const rejectCookies = () => {
    setConsentGiven(false);
    localStorage.setItem("cookieConsent", "rejected");

    // Optional: Send analytics event for rejection
    // gtag('event', 'consent_rejected');
  };

  return (
    <ConsentContext.Provider
      value={{ consentGiven, acceptCookies, rejectCookies }}
    >
      {children}
    </ConsentContext.Provider>
  );
};

export const useConsent = () => {
  const context = useContext(ConsentContext);
  if (!context) {
    throw new Error("useConsent must be used within ConsentProvider");
  }
  return context;
};

// Function to initialize GA (called only after consent)
// In your ConsentContext.tsx
const initializeGoogleAnalytics = () => {
  if (typeof window === "undefined" || window.gtag) return;

  console.log("GA Init");

  // Create script
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-DLMV5GKLE0"; // Replace!
  document.head.appendChild(script);

  // Initialize dataLayer and gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", "G-DLMV5GKLE0"); // Replace with your ID
};
